<script setup lang="ts">
import {Knowledgeable} from "@/knowledge-box/interfaces";
import {Dialog, DialogContent, DialogHeader, DialogTrigger, DialogTitle, DialogDescription} from "@/core/components/ui/dialog";
import KnowledgeableChat from "@/knowledge-box/components/KnowledgeableChat.vue";
import Icon from "@/core/components/icon/Icon.vue";

const {knowledgeable} = defineProps<{
    knowledgeable: Knowledgeable;
}>();
</script>

<template>
  <Dialog>
    <DialogTrigger as-child>
      <slot name="trigger" />
    </DialogTrigger>
    <DialogContent
      class="max-w-lg md:max-w-xl lg:max-w-4xl" @pointer-down-outside="(event) => {
        event.preventDefault();
      }"
    >
      <DialogHeader class="text-start">
        <div class="hidden">
          <DialogTitle>{{ knowledgeable.knowledge_box.title }}</DialogTitle>
          <DialogDescription>{{ knowledgeable.knowledge_box.description }}</DialogDescription>
        </div>
        <h1>
          Demandez conseil à l'IA
          <Icon color="primary" name="mdi-creation" class="ml-1" :size="20" />
        </h1>
        <div class="flex gap-2">
          <div
            v-if="knowledgeable.knowledge_box.logo"
            :key="knowledgeable.id"
            class="h-12 max-w-44 mr-2 shrink-0"
          >
            <img :src="knowledgeable.knowledge_box.logo.url" :alt="`logo`" class="object-fill h-full">
          </div>
          <p>
            Obtenez des réponses instantanées grâce à l'expertise <strong>{{ knowledgeable.knowledge_box.title }}
              {{ knowledgeable.knowledge_box.description ? `- ${knowledgeable.knowledge_box.description}` : '' }}</strong>
          </p>
        </div>
      </DialogHeader>
      <KnowledgeableChat :knowledgeable="knowledgeable" />
    </DialogContent>
  </Dialog>
</template>
